import type { Lucid } from '../types/types';

const helpCenterLinks: Record<Exclude<Lucid.I18n.LanguagesShortCode, 'da' | 'sv' | 'ko' | 'pl'>, string> = {
  de: 'https://lucidscale.zendesk.com/hc/de',
  en: 'https://lucidscale.zendesk.com/hc/en-us',
  es: 'https://lucidscale.zendesk.com/hc/es-419',
  fr: 'https://lucidscale.zendesk.com/hc/fr',
  it: 'https://lucidscale.zendesk.com/hc/it',
  nl: 'https://lucidscale.zendesk.com/hc/nl',
  pt: 'https://lucidscale.zendesk.com/hc/pt',
  ru: 'https://lucidscale.zendesk.com/hc/ru',
  ja: 'https://lucidscale.zendesk.com/hc/ja',
};
const supportLinks: Record<Exclude<Lucid.I18n.LanguagesShortCode, 'da' | 'sv' | 'ko' | 'pl'>, string> = {
  de: 'https://lucidco.zendesk.com/hc/de/articles/360049229652-Support-anfordern',
  en: 'https://lucidco.zendesk.com/hc/en-us/articles/360049229652-Contact-Support',
  es: 'https://lucidco.zendesk.com/hc/es-419/articles/360049229652-Obtener-soporte-t%C3%A9cnico',
  fr: 'https://lucidco.zendesk.com/hc/fr/articles/360049229652-Obtenir-de-l-aide',
  it: 'https://lucidco.zendesk.com/hc/it/articles/360049229652-Ricevi-assistenza',
  nl: 'https://lucidco.zendesk.com/hc/nl/articles/360049229652-Ondersteuning',
  pt: 'https://lucidco.zendesk.com/hc/pt/articles/360049229652-Obter-suporte',
  ru: 'https://lucidco.zendesk.com/hc/ru/articles/360049229652-%D0%9F%D0%BE%D0%B4%D0%B4%D0%B5%D1%80%D0%B6%D0%BA%D0%B0',
  ja: 'https://lucidco.zendesk.com/hc/ja/articles/360049229652-%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%81%B8%E3%81%AE%E5%95%8F%E3%81%84%E5%90%88%E3%82%8F%E3%81%9B',
};

const getZendeskLinks = (language: Lucid.I18n.LanguagesShortCode) => ({
  helpCenterLink: helpCenterLinks[language] || helpCenterLinks.en,
  supportLink: supportLinks[language] || supportLinks.en,
});

export default getZendeskLinks;
